import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/general/tevo-label.png'
import _imports_1 from '@/assets/logo/logo-white.png'


const _withScopeId = n => (_pushScopeId("data-v-7825ba3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer-placeholder" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-placeholder col-12" }, null, -1))
const _hoisted_3 = { class: "bg-dark text-white col-12 flex-centered" }
const _hoisted_4 = { class: "container-lg" }
const _hoisted_5 = { class: "row justify-content-lg-between mt-4 mt-lg-0" }
const _hoisted_6 = { class: "col-12 col-sm-6 col-lg-2 text-center text-lg-start mb-4 mb-lg-0" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h5 text-uppercase fw-bold mb-1" }, "Quick link", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-address col-12 col-sm-6 col-lg-3 text-center text-lg-start mb-4 mb-lg-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "h5 text-uppercase fw-bold mb-1" }, "Address"),
  /*#__PURE__*/_createElementVNode("p", null, "70 Armstrong Avenue"),
  /*#__PURE__*/_createElementVNode("p", null, "Building 2, Upper Level"),
  /*#__PURE__*/_createElementVNode("p", null, "La Lucia Ridge, 4051"),
  /*#__PURE__*/_createElementVNode("p", null, "KwaZulu Natal, South Africa")
], -1))
const _hoisted_9 = { class: "col col-lg-3 text-center text-lg-start mb-4 mb-lg-0" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h5 text-uppercase fw-bold mb-1" }, "Corporate", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-lg text-center mb-4 mb-lg-0" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "img-fluid",
    src: _imports_0,
    style: {"max-height":"90px"},
    alt: "Proudly backed by Tevo, the makers of the Magneto LED Lantern"
  })
], -1))
const _hoisted_12 = { class: "col-12 col-lg text-center text-lg-start mb-4 mb-lg-0" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ms-lg-1" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "img-fluid",
    src: _imports_1,
    alt: "Magneto Renewable Energy logo"
  })
], -1))
const _hoisted_14 = { class: "mt-2 mb-0 ms-lg-2 copyright" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("footer", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_router_link, {
              to: {name: 'ResidentialAboutUs'},
              class: "text-white d-block"
            }, {
              default: _withCtx(() => [
                _createTextVNode("About us")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: {name: 'ResidentialProductRange'},
              class: "text-white d-block"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Products")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: {name: 'ResidentialSolutions'},
              class: "text-white d-block"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Solutions")
              ]),
              _: 1
            })
          ]),
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_router_link, {
              to: {name: 'TermsAndConditions'},
              class: "text-white d-block"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Terms & Conditions")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: {name: 'PrivacyPolicy'},
              class: "text-white d-block"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Privacy Policy")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: {name: 'ResidentialWarrantyRegistration'},
              class: "text-white d-block"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Register Your Warranty")
              ]),
              _: 1
            })
          ]),
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("p", _hoisted_14, "© " + _toDisplayString(new Date().getFullYear()) + " Magneto Renewable Energy", 1)
          ])
        ])
      ])
    ])
  ]))
}